import React from 'react'
import View from './view'

const EventAdmin = ({ ...props }) => {
    return <View {...props} />
}

export default EventAdmin
